export default "__VITE_ASSET__jbt6Vr83__"